<div class="wrapper-replay">
  <div class="section-title">
    <div class="d-flex align-items-center">
      <a routerLink="/dashboard/visitor-intelligence" class="btn btn-back" [attr.aria-label]="'Back' | translate">
        <i class="fi-rr-arrow-alt-left"></i>
      </a>
      <div class="title" [attr.data-parent]="'Visitor Intelligence' | translate">{{ "Heatmap" | translate }}</div>
    </div>
  </div>

  <div class="section-main mt-3">
    <div class="d-flex justify-content-end mb-3">
      <button type="button" class="btn btn-outline-primary-filter" (click)="openFilter(filterHeatmap)">
        <div class="d-flex align-items-center gap-2">
          <div class="icon-filter"></div>
          <span>{{ "Filter" | translate }}</span>
        </div>
      </button>
    </div>

    <div class="info-card mb-3">
      <i class="fi fi-rr-info me-2"></i>
      {{ "Heatmap data updates every hour. You may not see the latest clicks and interactions right away." | translate }}
    </div>


    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div *ngIf="!isLoading && sessions.length === 0" class="empty-state text-center py-5">
      <i class="fi fi-rr-cursor" style="font-size: 3rem; color: #ccc;"></i>
      <p class="mt-3 text-muted">{{ "No heatmap data available yet." | translate }}</p>
    </div>

    <div *ngIf="!isLoading && sessions.length > 0">
      <div class="row">
        <div class="col-lg-12 col-sm-12 mb-3" *ngFor="let s of sessions">
          <div class="card session-card">
            <div class="row card-items align-items-center">
              <div class="col-6 col-md-1 text-center">
                <p class="property-text">{{ "Session" | translate }}</p>
                <p class="value-text">
                  <span class="badge bg-light text-dark font-monospace">{{ shortId(s.session_id) }}</span>
                </p>
              </div>
              <div class="col-6 col-md-1 text-center">
                <p class="property-text">{{ "Page" | translate }}</p>
                <p class="value-text">{{ s.page || '-' }}</p>
              </div>
              <div class="col-6 col-md-2 text-center">
                <p class="property-text">{{ "Platform" | translate }}</p>
                <p class="value-text">{{ s.platform || '-' }}</p>
              </div>
              <div class="col-6 col-md-1 text-center">
                <p class="property-text">{{ "Duration" | translate }}</p>
                <p class="value-text">{{ formatDuration(s.duration_ms) }}</p>
              </div>
              <div class="col-12 col-md-4 text-center">
                <div class="d-flex align-items-center justify-content-center gap-4">
                  <div>
                    <p class="property-text">{{ "Scroll Depth" | translate }}</p>
                    <div class="scroll-bar-wrap">
                      <div class="scroll-bar-fill" [style.width.%]="s.scroll_depth_pct"></div>
                    </div>
                    <p class="value-text mt-1">{{ s.scroll_depth_pct }}%</p>
                  </div>
                  <div>
                    <p class="property-text">{{ "Clicks" | translate }}</p>
                    <p class="value-text">{{ s.click_count }}</p>
                  </div>
                  <div>
                    <p class="property-text">{{ "Rage" | translate }}</p>
                    <p class="value-text" [class.text-danger]="s.rage_click_count > 0">{{ s.rage_click_count }}</p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-3 text-center">
                <button class="btn btn-sm btn-primary btn-action" (click)="viewHeatmap(s.session_id)">
                  {{ "View Heatmap" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row px-4 py-3 pagination-row" *ngIf="totalRecord > pageSize">
        <div class="col-lg-3 flex">
          <ngb-pagination
            [collectionSize]="totalRecord"
            [(page)]="currentPage"
            [pageSize]="pageSize"
            aria-label="Heatmap session pagination"
            [ellipses]="false"
            [rotate]="true"
            [maxSize]="5"
            (pageChange)="onPageChange()"
          ></ngb-pagination>
        </div>
        <div class="col-lg-3 lg-center">
          <div class="mt-2 text-center">
            {{ "Showing" | translate }} <b>{{ start + 1 }}–{{ end }}</b> {{ "of" | translate }}
            <b>{{ totalRecord }}</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #filterHeatmap let-modal>
  <div class="modal-filter-header">
    <h4 class="modal-title">{{ "Filter" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-filter-body">
    <div class="modal-filter-body-items">
      <div class="text-subtitle mb-2">{{ "Date" | translate }}</div>
      <div class="form-group">
        <div ngbDropdown class="d-inline-block w-100">
          <button class="btn btn-outline-primary-filter w-100" ngbDropdownToggle>
            {{ selectedDateFilter.display | translate }}
          </button>
          <div ngbDropdownMenu class="custom-dropdown-filter w-100">
            <button
              ngbDropdownItem
              *ngFor="let f of DATE_FILTERS"
              [class.active]="f.value === selectedDateFilter.value"
              (click)="selectDateFilter(f); modal.dismiss()"
            >
              {{ f.display | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
